




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Picker, Popup } from 'vant';
Vue.use(Picker).use(Popup);
@Component
export default class PickerInput extends Vue {
  @Prop() title!: string;
  @Prop() PickerData!: any;
  @Prop({ default: '请选择' }) placeholder!: string;
  value: string = '';
  showPicker: boolean = false;
  PickerValue: any[] = [];
  PickerId: any[] = [];
  startPicker() {
    this.PickerValue = this.PickerData.map((officer: any) => officer.value);
    this.PickerId = this.PickerData.map((officer: any) => officer.id);
    this.showPicker = true;
  }
  onConfirm(e: string, index: number) {
    console.log('e,', e, this.PickerId[index]);
    this.$emit('selectData', e, this.PickerId[index]);
    this.value = e;
    this.showPicker = false;
  }
}
